import React from "react";
import Skeleton from "react-loading-skeleton";

export default function ProductCardLoader() {
  return (
    <div className="d-flex justify-content-start align-items-center products-scroll-container">
      {Array.from({ length: 10 }).map((_, index) => (
        <div
          className="d-flex flex-column align-items-center justify-content-center me-2"
          key={index}
        >
          <Skeleton
            key={index}
            width={200}
            height={250}
            containerClassName="d-flex w-100 products-item me-2"
            style={{ aspectRatio: "1/1" }}
          />
          <Skeleton width={200} />
        </div>
      ))}
    </div>
  );
}
